import React, { ComponentProps } from 'react';
import { Box, Typography, TextField, SxProps } from '@mui/material';

type MuiTextFieldProps = ComponentProps<typeof TextField>;

interface DosenInputProps extends MuiTextFieldProps {
  label?: string;
  maxChars?: number;
  minChars?: number;
  inputSx?: SxProps;
}

export default function DosenInput({
  label,
  value = '',
  onChange,
  placeholder,
  multiline,
  rows,
  disabled,
  type,
  helperText,
  maxChars,
  minChars,
  sx = {},
  inputSx = {},
  InputProps,
  ...rest
}: DosenInputProps) {
  const length = String(value)?.length || 0;
  const showCounter = maxChars !== undefined || minChars !== undefined;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        fontFamily: 'Open Sans !important',
        ...sx
      }}
    >
      {(label || showCounter) && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {label && (
            <Typography
              sx={{
                color: '#FDFDFD',
                fontSize: '14px',
                fontFamily: 'Open Sans !important',
                fontWeight: 500
              }}
            >
              {label}
            </Typography>
          )}

          {showCounter && (
            <Typography
              sx={{
                color: '#868686',
                fontSize: '12px',
                fontFamily: 'Open Sans !important'
              }}
            >
              {maxChars ? `${length}/${maxChars}` : `${length}/${minChars}+`}
            </Typography>
          )}
        </Box>
      )}

      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        multiline={multiline}
        rows={rows}
        disabled={disabled}
        type={type}
        helperText={helperText}
        InputProps={{
          ...(InputProps || {}),
          inputProps: {
            ...(InputProps?.inputProps || {}),
            maxLength: maxChars
          }
        }}
        fullWidth
        {...rest}
        sx={{
          fontFamily: 'Open Sans !important',

          /** ROOT */
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'rgba(0,0,0,0.70) !important',
            borderRadius: '6px',
            fontFamily: 'Open Sans !important',

            '& fieldset': {
              borderColor: '#868686 !important'
            },
            '&:hover fieldset': {
              borderColor: '#868686 !important'
            },
            '&.Mui-focused fieldset': {
              borderColor: '#868686 !important'
            },
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0,0,0,0.70) !important',
              opacity: 0.6
            }
          },

          /** INPUT */
          '& .MuiInputBase-input': {
            backgroundColor: 'transparent !important',
            color: '#FDFDFD !important',
            padding: '10px 12px',
            fontSize: '14px',
            fontFamily: 'Open Sans !important'
          },

          /** PLACEHOLDER */
          '& .MuiInputBase-input::placeholder': {
            color: '#868686 !important',
            opacity: 1,
            fontFamily: 'Open Sans !important'
          },

          /** MULTILINE */
          '& .MuiOutlinedInput-inputMultiline': {
            backgroundColor: 'transparent !important',
            color: '#FDFDFD !important',
            padding: '10px 12px',
            fontFamily: 'Open Sans !important'
          },

          /** ROOT BASE */
          '& .MuiInputBase-root': {
            backgroundColor: 'rgba(0,0,0,0.70) !important',
            fontFamily: 'Open Sans !important'
          },

          /** HELPER TEXT */
          '& .MuiFormHelperText-root': {
            color: '#B6B6B6 !important',
            fontSize: '12px',
            marginLeft: '4px',
            fontFamily: 'Open Sans !important'
          },

          /** LABEL (caso use variant="outlined" com label flutuante) */
          '& .MuiInputLabel-root': {
            color: '#FDFDFD !important',
            fontFamily: 'Open Sans !important'
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#FDFDFD !important',
            fontFamily: 'Open Sans !important'
          },

          /** CONTADOR E TIPOS DE TEXTO INTERNOS */
          '& .MuiTypography-root': {
            fontFamily: 'Open Sans !important'
          },

          ...inputSx
        }}
      />
    </Box>
  );
}
